import { buttonClass } from "../../components/Button";
import { Link } from "react-router";
import { Banner } from "../../components/Banner";
import { ScreenHeader } from "../../components/ScreenHeader";
import { useSession } from "../../lib/session";

/** The celebration screen after clearing a gate. The server has already recorded the clearance. */
export function DoneScreen({
  kicker,
  title,
  sub,
  next,
}: {
  kicker: string;
  title: string;
  sub: string;
  next?: { to: string; label: string };
}) {
  const { user } = useSession();
  return (
    <div>
      <ScreenHeader kicker={kicker} title={title} sub={sub} />
      <Banner tone="good">✓ Recorded against {user?.email}.</Banner>
      <div className="flex flex-wrap gap-2.5">
        {next ? (
          <Link to={next.to} className={buttonClass("primary")}>
            {next.label} →
          </Link>
        ) : null}
        <Link to="/hub" className={buttonClass("ghost")}>
          Back to my steps
        </Link>
      </div>
    </div>
  );
}
